import React from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.div<{
  background: string | undefined;
  textColor: string | undefined;
  disabled: boolean;
  width: string | undefined;
  border: string | undefined;
  large: boolean;
  style?: React.CSSProperties;
}>`
  border-radius: 4px;
  background-color: ${(props) => (props.background ? props.background : '#1c232c')};
  color: ${(props) => (props.textColor ? props.textColor : '#fff')};
  padding: ${(props) => (props.large ? '24px' : '16px')};
  font-size: ${(props) => (props.large ? '18px' : '14px')};
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 24px;
  text-align: center;
  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
  width: ${(props) => (props.width ? props.width : 'auto')};
  border: ${(props) => (props.border ? props.border : 'none')};
  box-sizing: border-box;
  transition: opacity 0.2s ease-in-out;
`;

interface Props {
  text: React.ReactNode;
  handleClick: () => void;
  background?: string;
  textColor?: string;
  disabled?: boolean;
  width?: string;
  border?: string;
  large?: boolean;
  style?: React.CSSProperties;
}

const Button: React.FunctionComponent<Props> = ({
  text,
  handleClick,
  background,
  textColor,
  disabled,
  width,
  border,
  large,
  style,
}) => {
  return (
    <Wrapper
      onTouchStart={!disabled ? handleClick : undefined}
      background={background}
      width={width}
      textColor={textColor}
      border={border}
      disabled={Boolean(disabled)}
      large={Boolean(large)}
      style={style}>
      {text}
    </Wrapper>
  );
};

export default Button;
